import { useRef, useState } from 'react'
import { Payment } from '../../../generated'
import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material'
import { PrimaryDots } from '../../assets/images'
import { anchorOrigin, transformOrigin } from '../../theme/styleConstants'

interface PaymentsMenuProps {
  payment: Payment
  onEdit: (paymentId: string) => void
  onView: (paymentId: string) => void
  onDelete?: (paymentId: string) => void
  /** Only shows the Delete item when the caller has decided this payment can be deleted. */
  canDelete?: boolean
}

const PaymentsMenu = ({ payment, onEdit, onView, onDelete, canDelete }: PaymentsMenuProps) => {
  const [open, setOpen] = useState(false)
  const { id } = payment

  const handleClick = () => setOpen(!open)
  const handleClose = () => setOpen(false)

  const handleEdit = () => {
    onEdit(id)
    handleClose()
  }

  const handleView = () => {
    onView(id)
    handleClose()
  }

  const handleDelete = () => {
    onDelete?.(id)
    handleClose()
  }

  const anchorRef = {
    [id]: useRef<HTMLButtonElement>(null)
  }

  return (
    <Box>
      <IconButton
        ref={anchorRef[id]}
        id={`long-button-${id}`}
        aria-controls={`long-menu-${id}`}
        aria-haspopup="true"
        onClick={handleClick}
        aria-label="show more"
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      <Menu
        id={`long-menu-${id}`}
        anchorEl={anchorRef[id].current}
        open={open}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
      >
        <MenuItem onClick={handleView}>View</MenuItem>
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        {canDelete && onDelete && (
          <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
            Delete
          </MenuItem>
        )}
      </Menu>
    </Box>
  )
}

export default PaymentsMenu
